import { render, staticRenderFns } from "./ItemsJsFacets.vue?vue&type=template&id=dc17b938&"
import script from "./ItemsJsFacets.vue?vue&type=script&lang=js&"
export * from "./ItemsJsFacets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports